// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Notifications_notifications__MwHVM{
    position: absolute;
    top: 60px;
    left: 0;
    max-height: 550px;
    width: 100%;
    padding: 5px 18px;
    background-color: #FFFFFF;
    border: 1px solid #1F363D1A;
    border-radius: 10px;
    box-shadow: 0 3px 12px 0 #00000012;
    overflow-y: auto;
}
@media(max-width: 600px){
    .Notifications_notifications__MwHVM{
        width: calc(100% - 20px);
    }
}
@media(max-width: 500px){
    .Notifications_notifications__MwHVM{
        left: -140px;
        width: calc(100% + 120px);
    }
}
.Notifications_notification__3RgBI{
    display: flex;
    position: relative;
    padding: 15px 0;
    color: #1F363D;
    font-size: 14px;
    text-decoration: none;
}
.Notifications_notification__3RgBI:not(:first-child){
    border-top: 1px solid #1F363D1A;
}
.Notifications_notificationBell__V7gbY{
    position: relative;
    top: 3px;
    height: 12.5px;
    width: 12.5px;
}
.Notifications_middleSection__WVoAZ{
    width: calc(100% - 70px);
    margin-left: 20px;
}
.Notifications_text__0Nwx5{
    white-space: pre-line;
}
.Notifications_datetime__jtald{
    margin-top: 5px;
    color: #1F363D;
    font-size: 12px;
    opacity: 60%;
}
.Notifications_eyeCircleRed__rZQ\\+9{
    position: relative;
    height: 16px;
    width: 16px;
    margin-left: auto;
}
.Notifications_noNotifications__Re-Bh{
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100%;
    width: 100%;
    padding: 20px 0;
    color: #1F363D;
    font-size: 12px;
}`, "",{"version":3,"sources":["webpack://./src/components/logged-in/Notifications.module.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,SAAS;IACT,OAAO;IACP,iBAAiB;IACjB,WAAW;IACX,iBAAiB;IACjB,yBAAyB;IACzB,2BAA2B;IAC3B,mBAAmB;IACnB,kCAAkC;IAClC,gBAAgB;AACpB;AACA;IACI;QACI,wBAAwB;IAC5B;AACJ;AACA;IACI;QACI,YAAY;QACZ,yBAAyB;IAC7B;AACJ;AACA;IACI,aAAa;IACb,kBAAkB;IAClB,eAAe;IACf,cAAc;IACd,eAAe;IACf,qBAAqB;AACzB;AACA;IACI,+BAA+B;AACnC;AACA;IACI,kBAAkB;IAClB,QAAQ;IACR,cAAc;IACd,aAAa;AACjB;AACA;IACI,wBAAwB;IACxB,iBAAiB;AACrB;AACA;IACI,qBAAqB;AACzB;AACA;IACI,eAAe;IACf,cAAc;IACd,eAAe;IACf,YAAY;AAChB;AACA;IACI,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,iBAAiB;AACrB;AACA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,YAAY;IACZ,WAAW;IACX,eAAe;IACf,cAAc;IACd,eAAe;AACnB","sourcesContent":[".notifications{\n    position: absolute;\n    top: 60px;\n    left: 0;\n    max-height: 550px;\n    width: 100%;\n    padding: 5px 18px;\n    background-color: #FFFFFF;\n    border: 1px solid #1F363D1A;\n    border-radius: 10px;\n    box-shadow: 0 3px 12px 0 #00000012;\n    overflow-y: auto;\n}\n@media(max-width: 600px){\n    .notifications{\n        width: calc(100% - 20px);\n    }\n}\n@media(max-width: 500px){\n    .notifications{\n        left: -140px;\n        width: calc(100% + 120px);\n    }\n}\n.notification{\n    display: flex;\n    position: relative;\n    padding: 15px 0;\n    color: #1F363D;\n    font-size: 14px;\n    text-decoration: none;\n}\n.notification:not(:first-child){\n    border-top: 1px solid #1F363D1A;\n}\n.notificationBell{\n    position: relative;\n    top: 3px;\n    height: 12.5px;\n    width: 12.5px;\n}\n.middleSection{\n    width: calc(100% - 70px);\n    margin-left: 20px;\n}\n.text{\n    white-space: pre-line;\n}\n.datetime{\n    margin-top: 5px;\n    color: #1F363D;\n    font-size: 12px;\n    opacity: 60%;\n}\n.eyeCircleRed{\n    position: relative;\n    height: 16px;\n    width: 16px;\n    margin-left: auto;\n}\n.noNotifications{\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    height: 100%;\n    width: 100%;\n    padding: 20px 0;\n    color: #1F363D;\n    font-size: 12px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"notifications": `Notifications_notifications__MwHVM`,
	"notification": `Notifications_notification__3RgBI`,
	"notificationBell": `Notifications_notificationBell__V7gbY`,
	"middleSection": `Notifications_middleSection__WVoAZ`,
	"text": `Notifications_text__0Nwx5`,
	"datetime": `Notifications_datetime__jtald`,
	"eyeCircleRed": `Notifications_eyeCircleRed__rZQ+9`,
	"noNotifications": `Notifications_noNotifications__Re-Bh`
};
export default ___CSS_LOADER_EXPORT___;
